(() => {
  'use strict';
  const states = new WeakMap();
  const focusable = 'a[href],button,input:not([type="hidden"]),select,textarea,summary,[tabindex]';
  const visible = el => !el.disabled && el.tabIndex >= 0 && !el.closest('[inert],[hidden],[aria-hidden="true"]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
  const items = root => [...root.querySelectorAll(focusable)].filter(visible);
  let lastAction = null;
  let cartSnapshot = new Map();
  const readCart = root => new Map([...root.querySelectorAll('#ThemeCartDialog .cart-item_parent')].map(row => {
    const key = row.querySelector('[data-itemkey]')?.getAttribute('data-itemkey') || row.getAttribute('data-product-id');
    return [key, { title: row.querySelector('.cart-item__title[data-theme-a11y]')?.textContent.trim(), quantity: Number(row.querySelector('.quantity_input')?.value || 0) }];
  }));
  const cartFromHTML = html => typeof html === 'string' ? readCart(new DOMParser().parseFromString(html, 'text/html')) : null;
  const announce = names => {
    const status = document.getElementById('ThemeCartStatus');
    if (!status) return;
    status.textContent = '';
    setTimeout(() => { status.textContent = names.length ? `Added to cart: ${names.join(', ')}.` : 'Added to cart.'; }, 100);
  };
  const background = (root, enabled, state) => {
    if (enabled) {
      state.background = [];
      for (let branch = root; branch && branch !== document.body; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) {
          if (sibling === branch || ['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) continue;
          state.background.push([sibling, sibling.inert]);
          sibling.inert = true;
        }
      }
    } else {
      state.background.forEach(([el, inert]) => { el.inert = inert; });
      state.background = [];
    }
  };
  function drawerState(root, open, kind) {
    let state = states.get(root);
    if (!state) {
      state = { open: false, background: [], opener: null };
      states.set(root, state);
      root.addEventListener('keydown', event => {
        if (!state.open) return;
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopPropagation();
          root.querySelector(kind === 'cart' ? '[data-theme-cart-close]' : '[data-theme-nav-close]')?.click();
        } else if (event.key === 'Tab') {
          const targets = items(root), first = targets[0], last = targets.at(-1);
          if (!first) { event.preventDefault(); (root.querySelector('#ThemeCartTitle') || root).focus(); }
          else if (event.shiftKey && (document.activeElement === first || !targets.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
        }
      });
      document.addEventListener('focusin', event => {
        if (state.open && !root.contains(event.target)) (items(root)[0] || root).focus();
      });
    }
    if (state.open === Boolean(open)) return;
    state.open = Boolean(open);
    if (open) {
      state.opener = kind === 'cart' && lastAction && !root.contains(lastAction) ? lastAction : document.activeElement;
      root.inert = false; root.removeAttribute('aria-hidden');
      background(root, true, state);
      requestAnimationFrame(() => {
        if (state.open) (root.querySelector('#ThemeCartTitle') || items(root)[0] || root).focus();
      });
    } else {
      background(root, false, state);
      const opener = state.opener;
      if (opener?.isConnected && visible(opener)) opener.focus();
      else if (kind === 'cart') {
        const card = opener?.closest('.product_card');
        const fallback = card?.querySelector('[data-theme-quick-open]') || [...document.querySelectorAll('[data-theme-cart-open]')].find(visible);
        fallback?.focus();
      }
      root.inert = true; root.setAttribute('aria-hidden', 'true');
      if (kind === 'cart') lastAction = null;
    }
  }
  window.KatzThemeA11y = {
    drawerState,
    openCartFromNav() {
      const nav = document.getElementById('nav-drawer');
      nav?.querySelector('[data-theme-nav-close]')?.click();
      if (nav) drawerState(nav, false, 'nav');
      requestAnimationFrame(() => { window.Alpine.store('cart').isOpen = true; });
    }
  };
  document.addEventListener('click', event => {
    const action = event.target.closest('[data-theme-add],[data-theme-cart-open]');
    if (action && !action.closest('#ThemeCartDialog')) lastAction = action;
  }, true);
  window.addEventListener('cart-product-added', event => {
    const added = event.detail?.items || [event.detail];
    const names = added.map(item => item?.product_title || item?.title).filter(Boolean);
    announce(names);
    cartSnapshot = cartFromHTML(event.detail?.sections?.['ajax-cart']) || cartSnapshot;
  });
  window.addEventListener('cart-frequently-bought', event => {
    const next = cartFromHTML(event.detail);
    if (!next) return;
    const added = [...next].filter(([key, item]) => item.quantity > (cartSnapshot.get(key)?.quantity || 0)).map(([,item]) => item.title).filter(Boolean);
    if (added.length) announce(added);
    cartSnapshot = next;
  });
  window.addEventListener('cart-quantity-changed', event => {
    cartSnapshot = cartFromHTML(event.detail?.sections?.['ajax-cart']) || cartSnapshot;
  });
  document.addEventListener('DOMContentLoaded', () => {
    cartSnapshot = readCart(document);
    document.querySelectorAll('[data-theme-navigation]').forEach(nav => {
      nav.addEventListener('keydown', event => {
        const trigger = event.target.closest('[data-menu-trigger]');
        const active = nav.querySelector('[data-menu-trigger][aria-expanded="true"]');
        const panel = active && document.getElementById(active.getAttribute('aria-controls'));
        if (!active || !panel) return;
        const targets = items(panel);
        const subTrigger = event.target.closest('[data-theme-submenu-trigger]');
        const openSubTrigger = nav.querySelector('[data-theme-submenu-trigger][aria-expanded="true"]');
        const subPanel = openSubTrigger && document.getElementById(openSubTrigger.getAttribute('aria-controls'));
        const subTargets = subPanel ? items(subPanel) : [];
        if (event.key === 'Tab' && !event.shiftKey && event.target.matches('[data-theme-parent-link]')) {
          const topLinks = items(nav.querySelector('ul'));
          const next = topLinks[topLinks.indexOf(active) + 1];
          if (next) { event.preventDefault(); active.click(); next.focus(); }
        } else if (event.key === 'Tab' && subTrigger === openSubTrigger && !event.shiftKey && subTargets.length) {
          event.preventDefault(); subTargets[0].focus();
        } else if (event.key === 'Tab' && event.shiftKey && event.target === subTargets[0]) {
          event.preventDefault(); openSubTrigger.focus();
        } else if (event.key === 'Tab' && !event.shiftKey && event.target === subTargets.at(-1)) {
          const row = openSubTrigger.closest('li');
          const next = row.nextElementSibling?.querySelector('a,button');
          if (next) { event.preventDefault(); next.focus(); }
        } else if (event.key === 'Tab' && trigger === active && !event.shiftKey && targets.length) {
          event.preventDefault(); targets[0].focus();
        } else if (event.key === 'Tab' && event.shiftKey && event.target === targets[0]) {
          event.preventDefault(); active.focus();
        } else if (event.key === 'Tab' && !event.shiftKey && event.target === targets.at(-1)) {
          const topLinks = items(nav.querySelector('ul'));
          const next = topLinks[topLinks.indexOf(active) + 1];
          if (next) { event.preventDefault(); active.click(); next.focus(); }
        }
      });
    });
  });
})();
